import Image from "next/image";
import { ProductType } from "./ProductList";
import React from "react";
import { useRouter } from "next/navigation";
import FavoriteButton from "../FavoriteButton";
import toast from "react-hot-toast";
import apiService from "@/app/services/apiService";

interface ProductProps {
    product: ProductType,
    markFavorite?: (is_favorite: boolean) => void;
    isManageMode?: boolean;
}

const ProductListItem: React.FC<ProductProps> = ({
    product,
    markFavorite,
    isManageMode = false
}) => {
    const router = useRouter();
    const formattedPrice = product.price_per_night.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    const handleDelete = async () => {
        const confirmDelete = window.confirm('Tem certeza que deseja excluir este produto?')
        if (!confirmDelete) return

        try {
        await apiService.deleteWithToken(`/api/products/${product.id}/delete/`)
        toast.success('Ítem excluído do catálogo!')
        router.refresh?.()
        } catch (error) {
        toast.error('Erro ao excluir o ítem.')
        }
    }

    return (
        <div 
            className="cursor-pointer"
            onClick={() => router.push(`/products/${product.id}`)}
        >
            <div className="relative overflow-hidden aspect-square rounded-xl">
                <Image 
                    fill
                    src={product.image_url}
                    sizes="(max-width: 768px) 768px, (max-width: 1200px): 768px, 768px"
                    className="hover:scale-110 object-cover transition h-full w-full"
                    alt="Beach house"
                />

                {markFavorite && (
                    <FavoriteButton 
                        id={product.id}
                        is_favorite={product.is_favorite}
                        markFavorite={(is_favorite) => markFavorite(is_favorite)}
                    />
                )}
            </div>

            <div className="mt-2">
                <p className="text-lg font-bold">{product.title}</p>
            </div>

            <div className="mt-2">
                <p className="text-sm text-gray-500"><strong>{formattedPrice}</strong> a cortesia</p>
            </div>

            {isManageMode && (
                <div className="flex gap-2 mt-4">
                    <button
                        onClick={(e) => {
                        e.stopPropagation()
                        router.push(`/edit-product/${product.id}`)}}
                        className="px-3 py-1 text-sm bg-blue-500 text-white rounded"
                    >
                        Editar
                    </button>
                    <button
                        onClick={async (e) => {
                        e.stopPropagation()
                        await handleDelete()
                    }}
                        className="px-3 py-1 text-sm bg-red-500 text-white rounded"
                    >
                        Excluir
                    </button>
                </div>
            )}

        </div>
    )
}

export default ProductListItem;
